/**
 * Post-App Progress
 * Used to keep track of the number of steps / calculate the current 'index' of the user
 * Primarily used for the AppProgressCircles component
 */
import flinks from '@/mixins/flinks'

export default {
  mixins: [flinks],

  data () {
    return {
      incomeThresholdMin: 1800,
      incomeThresholdMax: 20000
    }
  },

  computed: {
    monthlyIncome () {
      return this.$store.state.application.monthly_income
    },

    shouldShowIncomeChanger () {
      return this.monthlyIncome < this.incomeThresholdMin || this.monthlyIncome > this.incomeThresholdMax
    },

    shouldShowDocumentsFlow () {
      return this.$store.state.application.show_uploader
    },

    shouldShowBanking () {
      return this.$store.state.application.show_flinks
    },

    progressStepsTotal () {
      let value = 3
      if (this.shouldShowIncomeChanger) value += 1
      if (this.shouldShowDocumentsFlow) value += 2
      if (this.shouldShowBanking && this.$_flinks_isEnabled) value += 2
      return value
    }
  }
}
